import React from 'react';
import { Link } from 'react-router-dom';
import NewsImage from '../components/NewsImage';
import NewsSkeleton from '../components/NewsSkeleton';
import SectionHeaderLink from '../components/SectionHeaderLink';
import { useSectionNewsBlockQuery } from '../hooks/useNewsListQuery';
import '../styles/LeagueNewsFeed.css';
import '../styles/HomeSectionTitle.css';

const LeagueNewsFeed = ({
  title,
  image,
  link,
  section,
  limit = 5,
}) => {
  const {
    news: newsList,
    initialLoading,
  } = useSectionNewsBlockQuery(section, limit);

  if (initialLoading && newsList.length === 0) {
    return <NewsSkeleton count={4} />;
  }

  if (newsList.length === 0) return null;

  return (
    <div className="league-news-feed">
      <SectionHeaderLink title={title} to={link} image={image} />

      <div className="league-news-feed__list">
        {newsList.map((news) => (
          <Link
            key={news.id}
            to={`/news/${news.id}`}
            className="league-news-feed__item"
          >
            <NewsImage
              news={news}
              alt={news.title}
              className="league-news-feed__image"
              loading="lazy"
            />

            <div className="league-news-feed__content">
              <h3 className="league-news-feed__item-title">
                {news.title}
              </h3>

              <span className="league-news-feed__time">
                {news.day}.{news.month}.{news.year}, {news.time}
              </span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default LeagueNewsFeed;
